require('popper.js');
//require('bootstrap');
require('datatables.net');

require('datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css');
require('datatables.net-bs4/css/dataTables.bootstrap4.min.css');
require('datatables.net-scroller-bs4/css/scroller.bootstrap4.min.css');
require('datatables.net-select-bs4/css/select.bootstrap4.min.css');

require('pdfmake/build/pdfmake.js');
require('pdfmake/build/vfs_fonts.js');
require( 'datatables.net-bs4' );
require( 'datatables.net-buttons-bs4');
require( 'datatables.net-colreorder');
require( 'datatables.net-buttons/js/buttons.colVis.js' );  // Column visibility
require( 'datatables.net-buttons/js/buttons.html5.js');
require( 'datatables.net-buttons/js/buttons.print.js' );
require( 'datatables.net-fixedcolumns-bs4' );
require( 'datatables.net-fixedheader-bs4' );
require( 'datatables.net-responsive-bs4' );
require( 'datatables.net-scroller-bs4' );
require( 'datatables.net-select-bs4' );
require( 'datatables.net-plugins/sorting/scientific.js' );
require( 'datatables.net-plugins/sorting/absolute.js' );
